var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center justify-center bg-white w-9 h-9 rounded-full shadow-md hover:bg-gray-50 transition ease-in-out duration-150"},[_c('i',{class:`text-sm fas ${_vm.icon} ${_vm.colorIcon}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }